import customFieldsActionCreators, { actionTypes } from './customFieldsActions';

export default customFieldsActionCreators;
export { actionTypes };
